export * from "./aggregatedCollection.mjs";
export * from "./mapCollection.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/translations/mapCollections/index.mjs
// module id = 1623
// module chunks = 1